import React from 'react';

import ActionButton from 'components/shared/Buttons/ActionButton';
import BaseModal from 'components/shared/Modal/BaseModal';

const CancelFailureModal = ({ closeModal, standardModalProps }) => (
  <BaseModal
    containerClassName="cancel-transaction-modal cancel-transaction-error-modal"
    {...standardModalProps}
    title="We were unable to process your request."
  >
    <div className="modal-body">
      <p>Call us at (800) 225-5132 to proceed.</p>
      <ActionButton
        id="cancel-transaction-failed-confirmed"
        onClick={closeModal}
        type="primary"
      >
        OK
      </ActionButton>
    </div>
  </BaseModal>
);

export default CancelFailureModal;
